import { useCallback, useEffect, useRef } from "react";
import { pdfTableStyle } from "../../../../../misc/pdf/parts/Page";
import { css } from "@emotion/css";
import { useReadyCheck } from "../../../../../misc/pdf/UseReadyCheck";
import { PdfTableServerRendered } from "./PdfTableServerRendered";
import { groupByPhase, phaseLabel } from "../../../../../misc/Phase";
import { jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
export function OpeningsPage(props) { const ready = useReadyCheck(props.onReady); ready.require(true); const toTable = (list, title) => ({ title: title, header: props.columns.map(c => c.display), content: list.map(d => props.columns.map(c => { var _d$c$key; if (c.render) {
        return c.render(d, props.drawingInfo).toString() || "";
    } return ((_d$c$key = d[c.key]) === null || _d$c$key === void 0 ? void 0 : _d$c$key.toString()) || ""; })) }); if (props.splitByPhase) {
    return /*#__PURE__*/ _jsx(_Fragment, { children: groupByPhase(props.data, d => d.phase).map(section => /*#__PURE__*/ _jsx(PdfTableServerRendered, { value: toTable(section.items, phaseLabel(section.phase)) }, section.phase)) });
} return /*#__PURE__*/ _jsx(_Fragment, { children: /*#__PURE__*/ _jsx(PdfTableServerRendered, { value: toTable(props.data) }) }); }
export function AutoShrinkTable(props) { const tableRef = useRef(null); const updateHeight = useCallback(() => { const t = tableRef.current; if (!t)
    return; t.style.marginBottom = ""; const hSmall = t.getBoundingClientRect().height; t.style.transform = "none"; const hBig = t.getBoundingClientRect().height; t.style.transform = ""; t.style.marginBottom = -(hBig - hSmall) / 2 + "px"; t.style.marginTop = -(hBig - hSmall) / 2 + "px"; }, []); useEffect(() => { updateHeight(); }); return /*#__PURE__*/ _jsx("table", { className: pdfTableStyle + " " + shrinkOnRender, style: { fontSize: "10px" }, ref: r => { tableRef.current = r; if (r) {
        updateHeight();
    } }, children: props.children }); }
const shrinkOnRender = css(`
@media print {
    width: 133%;
    transform: scale(0.75) translateX(-16.6%);
}

width: 133%;
transform: scale(0.75);
`);
